import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from '@mui/material/CircularProgress';

import {AVATAR_BASE_URL_API, BANNER_BASE_URL_API, BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {BasketComponent} from "./BasketComponent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {Link} from "react-router-dom";
import Paper from "@mui/material/Paper";
import {ProductStructList} from "../structs/ProductStructList";
import {ProductStruct} from "../structs/ProductStruct";
import Box from "@mui/material/Box";
import {MarketStructList} from "../structs/MarketStructList";
import {MarketStruct} from "../structs/MarketStruct";
import Typography from "@mui/material/Typography";
import {styled} from "@mui/material/styles";
import AliceCarousel from "react-alice-carousel";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {Grid} from "@mui/material";
import AvatarIcon from "../assets/icons/avatar.svg";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AddCardIcon from "@mui/icons-material/AddCard";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import SearchIcon from "@mui/icons-material/Search";
import {BottomMenu} from './HookUtils'

const items = [
    <div className="item" data-value="1">
        1
    </div>,
    <div className="item" data-value="2">
        2
    </div>,
    <div className="item" data-value="3">
        3
    </div>,
    <div className="item" data-value="4">
        4
    </div>,
    <div className="item" data-value="5">
        5
    </div>,
];

const drawerWidth = 240;
const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


export class OfferComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchResultProduct: [],
            searchResultMarket: [],
            banners: [],
            value: 0,
            userData: null,

            open: false,
            isLoading: true,
        }

    }


    componentDidMount() {
        fetch(BASE_URL_API + 'search?q=', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code === 200) {
                        let data = new ProductStructList();

                        for (let i = 0; i < results.data.products.length; i++) {
                            if (data.productList.length > 0) {
                                let size = data.productList.length;
                                for (let j = 0; j < size; j++) {
                                    if (results.data.products[i].category !== null && data.productList[j].category === results.data.products[i].category.title) {
                                        data.productList[j].productList.push(results.data.products[i])

                                        break
                                    } else {
                                        if (j === data.productList.length - 1) {
                                            if (results.data.products[i].category != null) {
                                                let productStruct = new ProductStruct()
                                                productStruct.category = results.data.products[i].category.title
                                                productStruct.productList.push(results.data.products[i])
                                                data.productList.push(productStruct)
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (results.data.products[i].category != null) {
                                    let productStruct = new ProductStruct()
                                    productStruct.category = results.data.products[i].category.title
                                    productStruct.productList.push(results.data.products[i])
                                    data.productList.push(productStruct)
                                }

                            }


                        }

                        let marketData = new MarketStructList();

                        for (let i = 0; i < results.data.markets.length; i++) {
                            if (marketData.marketList.length > 0) {
                                let size = marketData.marketList.length;
                                for (let j = 0; j < size; j++) {
                                    if (results.data.markets[i].category !== null && marketData.marketList[j].category === results.data.markets[i].category.title) {
                                        marketData.marketList[j].marketList.push(results.data.markets[i])

                                        break
                                    } else {
                                        if (j === marketData.marketList.length - 1) {
                                            let marketStruct = new MarketStruct()
                                            marketStruct.category = results.data.markets[i].category.title
                                            marketStruct.marketList.push(results.data.markets[i])
                                            marketData.marketList.push(marketStruct)

                                        }
                                    }
                                }
                            } else {
                                let marketStruct = new MarketStruct()
                                marketStruct.category = results.data.markets[i].category.title
                                marketStruct.marketList.push(results.data.markets[i])
                                marketData.marketList.push(marketStruct)
                            }


                        }


                        const offerList = data.productList.filter(function (item) {
                            return item.category.indexOf('داغ') !== -1
                        });

                        let difference = data.productList.filter(x => !offerList.includes(x));


                        var finalList = offerList.concat(bubbleSort(difference, difference.length))

                        this.setState({
                            searchResultProduct: finalList
                            , searchResultMarket: marketData.marketList
                        })

                        this.setState({isLoading: false})

                    }

                },
                (error) => {
                    console.log("error")
                }
            );

        fetch(BASE_URL_API + 'banner?type=home')
            .then(response => response.json())
            .then(results => {
                    this.setState({banners: results.data})

                },
                (error) => {
                    console.log("error")

                }
            );

        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        this.setState({userData: results.data})
                    }


                },
                (error) => {
                    console.log("error")

                }
            );

        function bubbleSort(arr, n) {
            var i, j, temp;
            var swapped;
            for (i = 0; i < n - 1; i++) {
                for (j = 0; j < n - i - 1; j++) {
                    if (arr[j].productList.length < arr[j + 1].productList.length) {
                        // Swap arr[j] and arr[j+1]
                        temp = arr[j];
                        arr[j] = arr[j + 1];
                        arr[j + 1] = temp;
                        swapped = true;
                    }
                }

                // IF no two elements were
                // swapped by inner loop, then break
            }

            return arr
        }
    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue})
    };

    handleDrawerClose = () => {
        this.setState({open: false})
    };

    handleDrawerOpen = () => {
        this.setState({open: true})
    };

    render() {


        let drawerOptionLinks = ['/transaction', '/order', "/about-us", "/privacy-policy"];

        const flexContainer = {
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            overflowY: 'hidden',
            height: 260,
            background: 'rgba(238,238,238,0.3)',
            align: 'right'
        };

        const MAX_LENGTH = 25;

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={this.handleDrawerOpen}
                            sx={{...(this.state.open && {display: 'none'})}}
                            size="large">
                            <MenuIcon style={{color: 'black'}}/>

                        </IconButton>

                        <ListItemText align="center"><strong style={{
                            width: '90%',
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }}>{"Hamekara"}</strong></ListItemText>

                        <IconButton component={Link} to={"/search"} style={{color: 'black'}} size="large"><SearchIcon/></IconButton>

                        <IconButton style={{color: 'black'}} size="large"> <BasketComponent/></IconButton>

                    </ToolbarMui>

                </AppBar>
                <Drawer sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                    }
                }}
                        variant="persistent"
                        anchor="right"
                        open={this.state.open}>
                    <DrawerHeader>
                        <IconButton onClick={this.handleDrawerClose} size="large">
                            <ChevronRightIcon/>
                        </IconButton>
                        {
                            (this.state.userData === null || this.state.userData.picture === null) ?
                                (<Grid container>
                                    <Grid xs={12}>
                                        <img style={{marginRight: 16}} alt="avatar2" src={AvatarIcon}/>
                                        {
                                            this.state.userData !== null ? <Typography style={{
                                                fontWeight: 'bold',
                                                fontSize: 18,
                                                marginBottom: 18,
                                                marginRight: 16,
                                                color: 'green',
                                            }}>{this.state.userData.name}</Typography> : ""
                                        }

                                    </Grid>

                                    {
                                        this.state.userData !== null ?
                                            <React.Fragment>
                                                <Grid xs={2}>
                                                    <PhoneIphoneIcon/>
                                                </Grid>
                                                <Grid xs={10}>

                                                    <Typography key={this.state.userData.phone} style={{
                                                        fontSize: 14,
                                                        color: 'gray',
                                                    }} align='right'>{this.state.userData.phone}
                                                    </Typography>
                                                </Grid>

                                                <Grid xs={2}>
                                                    <AddCardIcon/>
                                                </Grid>
                                                <Grid xs={10}>

                                                    <Typography key={this.state.userData.wallet} style={{
                                                        fontSize: 14,
                                                        color: 'gray'
                                                    }} align='right'>
                                                        {this.state.userData.wallet}
                                                    </Typography>

                                                </Grid>
                                            </React.Fragment>
                                            : ""

                                    }

                                </Grid>) : (
                                    <Grid container>
                                        <Grid xs={12}>
                                            <img style={{marginRight: 16}} alt="avatar2"
                                                 src={`${AVATAR_BASE_URL_API}${this.state.userData.picture.url}`}/>
                                            <Typography style={{
                                                fontWeight: 'bold',
                                                fontSize: 18,
                                                marginBottom: 18,
                                                marginRight: 16,
                                                color: 'green',
                                            }}>{this.state.userData.name}</Typography>
                                        </Grid>

                                        <Grid xs={2}>
                                            <PhoneIphoneIcon/>
                                        </Grid>
                                        <Grid xs={10}>

                                            <Typography key={this.state.userData.phone} style={{
                                                fontSize: 14,
                                                color: 'gray',
                                            }} align='right'>{this.state.userData.phone}
                                            </Typography>
                                        </Grid>

                                        <Grid xs={2}>
                                            <AddCardIcon/>
                                        </Grid>
                                        <Grid xs={10}>

                                            <Typography key={this.state.userData.wallet} style={{
                                                fontSize: 14,
                                                color: 'gray'
                                            }} align='right'>
                                                {this.state.userData.wallet}
                                            </Typography>

                                        </Grid>


                                    </Grid>
                                )

                        }


                    </DrawerHeader>

                    <Divider style={{marginTop: 50}}/>


                    <List>
                        {['سوابق تراکنش', 'سفارشات', 'درباره ما', 'قوانین و مقررات'].map((text, index) => (
                            <ListItem button key={text} component={Link}
                                      to={drawerOptionLinks[index]}>
                                <ListItemIcon>
                                    {index === 0 ? <PendingActionsOutlinedIcon/> : ""}
                                    {index === 1 ? <ShoppingBasketOutlinedIcon/> : ""}
                                    {index === 2 ? <ReduceCapacityOutlinedIcon/> : ""}
                                    {index === 3 ? <PrivacyTipOutlinedIcon/> : ""}
                                </ListItemIcon>
                                <ListItemText align='right'>{text}</ListItemText>
                            </ListItem>
                        ))}
                    </List>

                    <Divider/>

                </Drawer>
                <AliceCarousel autoPlay
                               autoPlayStrategy="none"
                               autoPlayInterval={2500}
                               animationDuration={1000}
                               infinite
                               touchTracking={false}
                               disableButtonsControls
                               items={items}>

                    {this.state.banners.map((banner, index) => (
                        <div    align='center'>
                            <img style={{   marginTop: 90,height:300,width:'80%', objectFit: 'contain'}} src={( BANNER_BASE_URL_API + banner.picture.url )}/>
                        </div>

                    ))}
                </AliceCarousel>
                <Box>
                    <div align='center'>
                        {this.state.isLoading === true ? (
                            <CircularProgress style={{
                                align: 'center'
                            }}/>
                        ) : ''}

                    </div>


                    {
                        this.state.searchResultProduct.map((product) => (
                            <Box key={product.id} style={{overflowX: 'hidden', overflowY: 'hidden', height: 320}}>
                                <ListItemText style={{margin: 16}}><strong>{product.category}</strong></ListItemText>

                                <List key={product.id} style={flexContainer}>
                                    {product.productList.map((product) => (

                                        <ListItem key={product.id} style={{width: 250}} component={Link}
                                                  to={"/product?id=" + product.id}>

                                            <Box style={{width: 150}}>
                                                <Paper style={{
                                                    width: 150,
                                                    height: 140,
                                                    align: 'center',
                                                    backgroundPosition: 'center',
                                                    backgroundSize: 'cover',
                                                    backgroundImage: 'url(' + (product.pictures.length > 0 ? PRODUCT_BASE_URL_API + product.pictures[0].url : "hamekara-logo.png") + ')'
                                                }}>


                                                </Paper>
                                                <ListItemText>
                                                    {product.title.length > MAX_LENGTH ?
                                                        (
                                                            <p key={product.id} style={{
                                                                fontSize: 14,
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                color: 'black'
                                                            }}
                                                               align='center'>
                                                                <strong>{`${product.title.substring(0, MAX_LENGTH)}...`}</strong>
                                                            </p>
                                                        ) :
                                                        <p key={product.id} style={{
                                                            fontSize: 14,
                                                            overflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            color: 'black'
                                                        }}
                                                           align='right'><strong>{product.title}</strong></p>
                                                    }

                                                    {product.markets !== null ?
                                                        (
                                                            <p key={product.id} style={{
                                                                fontSize: 10,
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                color: 'gray'
                                                            }}
                                                               align='right'>{`${product.markets.name}`}</p>
                                                        ) :
                                                        ""
                                                    }


                                                    {product.del_price > 0 ?
                                                        (
                                                            <React.Fragment>
                                                                <p key={product.id} style={{
                                                                    fontSize: 12,
                                                                    overflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    color: 'gray'
                                                                }}
                                                                   align='left'>
                                                                    <strong>{`${product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `}</strong>
                                                                </p>

                                                                <p key={product.id} style={{
                                                                    fontSize: 14,
                                                                    overflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    color: 'green'
                                                                }}
                                                                   align='left'>
                                                                    <strong>{`${(parseInt(product.price) - parseInt(product.del_price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `}</strong>
                                                                </p>
                                                            </React.Fragment>

                                                        ) :
                                                        <React.Fragment>
                                                            <p key={product.id} style={{
                                                                fontSize: 14,
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                color: 'green'
                                                            }}
                                                               align='left'>
                                                                <strong>{`${product.price > 0 ? product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ` تومان ` : `تماس بگیرید.`}`}</strong>
                                                            </p>
                                                        </React.Fragment>
                                                    }


                                                </ListItemText>
                                            </Box>

                                        </ListItem>

                                    ))
                                    }


                                </List>
                            </Box>

                        ))

                    }
                </Box>
                <BottomMenu/>
            </React.Fragment>
        );

    }
}
